import styled from "styled-components";
import { transparentize } from "polished";

import { Button, ButtonGroup } from "_/components/button";

export const Toolbar = styled(ButtonGroup)`
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;

  gap: 0.125rem;
  padding: 0.125rem;

  border: 1px solid ${(p) => p.theme.border.default};
  border-radius: 5px;
  background: ${(p) => transparentize(0.2, p.theme.sidebar.background)};
  box-shadow: 0 2px 8px rgb(0 0 0 / 25%);
`;

export const ToolbarButton = styled(Button)`
  width: 1.375rem;
  height: 1.375rem;
  padding: 0;

  font: 600 0.75rem/1 monospace;
`;
